import { useState } from 'react';

import { AppIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Button, SxProps, TextField, Theme } from '@mui/material';

import { FileUploadConfig } from '../types/profile.types';
import { isValidUrl } from '../utils/linkDocument.util';

const LINK_STRINGS = appStrings.modules.profile.modalUploader.document.link;

type ProfileDocumentLinkInputProps = Readonly<{
  fileUploadConfig: FileUploadConfig;
  onSubmit: (url: string) => void;
}>;

export const ProfileDocumentLinkInput = ({
  fileUploadConfig,
  onSubmit,
}: ProfileDocumentLinkInputProps) => {
  const [link, setLink] = useState('');

  const isLinkValid = isValidUrl(link);

  const showInvalidError = link.trim() !== '' && !isLinkValid;

  const handleSave = () => {
    if (!isLinkValid) return;

    onSubmit(link.trim());
    setLink('');
  };

  return (
    <Box sx={inputRowSx}>
      <TextField
        id={`${fileUploadConfig.type}-document-link-input`}
        fullWidth
        placeholder={LINK_STRINGS.placeholder}
        value={link}
        onChange={(e) => setLink(e.target.value)}
        error={showInvalidError}
        helperText={showInvalidError ? LINK_STRINGS.invalidUrl : ''}
      />
      <Button
        id={`${fileUploadConfig.type}-document-link-save-button`}
        hierarchy="Secondary gray"
        size="md"
        onClick={handleSave}
        sx={saveButtonSx}
      >
        <AppIcon iconName="ArrowRight" diameter="16px" color="Gray/900" />
      </Button>
    </Box>
  );
};

const inputRowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  gap: backrs.spacing['spacing-md'],
  alignItems: 'flex-start',
});

const saveButtonSx: SxProps<Theme> = {
  flexShrink: 0,
  minWidth: 0,
  width: '40px',
  height: '40px',
  p: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
};
